import React from 'react';
import {
  EdgeProps,
  getBezierPath,
  EdgeLabelRenderer,
  BaseEdge,
} from 'reactflow';
import { Typography } from '@mui/material';

const DefaultEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  selected,
}) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <>
      <BaseEdge
        path={edgePath}
        style={{
          stroke: selected ? '#1976d2' : '#999',
          strokeWidth: selected ? 3 : 2,
          opacity: 0.8,
        }}
      />
      {data?.label && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              pointerEvents: 'all',
            }}
          >
            <Typography
              variant="caption"
              style={{
                padding: '2px 6px',
                borderRadius: '4px',
                border: '1px solid rgba(0,0,0,0.12)',
                fontSize: '0.7rem',
                fontWeight: 500,
              }}
            >
              {data.label}
            </Typography>
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

export default DefaultEdge;
